const isBrowserAndHasNewrelic = () =>
	typeof window !== 'undefined' &&
	window.newrelic &&
	typeof window.newrelic === 'object';

/**
 *
 * @param {Error} error the caught error
 * @param {object} [customAttributes] extra key/value pairs to attach
 */
export const noticeError = (error, customAttributes = undefined) => {
	if (isBrowserAndHasNewrelic()) {
		window.newrelic.noticeError(error, customAttributes);
	}
};

export default noticeError;
